export default __webpack_public_path__ + "static/media/spd-pp-img.e6ae810c.webp";